<template>
    <div class="content">
        <div class="content-left">
            <div class="left-item" v-for="(item,index) in artCate" :key="index" @click="left_item(index)">
                <div class="left-item-img" v-if="item.piclink">
                    <img :src="/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/.test(item.piclink)?item.piclink:'https://www.yeying360.com'+item.piclink"/>
                </div>
                <div class="left-item-title">
                    <span>
                        <router-link :to="{path:'/article', query:{cate_id:item.id}}" target="_blank">
                            {{item.title}}
                        </router-link>
                    </span>
                </div>
            </div>
        </div>
        <div class="content-con">
            <div class="con-con">
                <span class="con-item" v-for="(item,index) in tableData.data" :key="index" :data-id="item.id">
                    <router-link :to="{path:'/article_detail', query:{id:item.id}}" target="_blank"  class="con-link">
                        <div class="con-item-img">
                            <img width="220" height="160" :src="item.piclink">
                        </div>
                        <div class="con-item-div">
                            <!-- <p class="con-item-p" style="overflow:hidden">{{item.title | ellipsis}}</p> -->
                            <p class="con-item-p" style="overflow:hidden">{{item.title}}</p>
                            <p class="con-item-p1" style="overflow:hidden">{{item.description}}</p>
                            <div class="con-div">
                                <em><i class="iconfont icon-chakan"></i> {{item.hit}}</em>
                                <span>{{$fnc.getTimeFormat(item.created_time)}}</span>
                            </div>
                        </div>
                    </router-link>
                </span>
            </div>
            <div class="page" id="pager">
                <el-pagination :page-sizes="[12,24,36,48]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
            </div>
        </div>
        <div class="content-right">
            <div class="right-top">
                <p>热门文章</p>
                <div class="right-item" v-for="(item,index) in list.data" :key="index">
                    <router-link :to="{path:'/article_detail', query:{id:item.id}}" target="_blank" class="right-a">
                        <!-- {{item.title}} -->
                        <div class="right-img">
                            <img width="100" height="70" :src="/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/.test(item.piclink)?item.piclink:'https://www.yeying360.com'+item.piclink">
                        </div>
                        <div class="right-title">
                            {{item.title}}
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="right-top">
                <p>精选文章</p>
                <div class="right-item" v-for="(item,index) in list1.data" :key="index">
                    <router-link :to="{path:'/article_detail', query:{id:item.id}}" target="_blank" class="right-a">
                        <div class="right-img">
                            <img width="100" height="70" :src="/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/.test(item.piclink)?item.piclink:'https://www.yeying360.com'+item.piclink">
                        </div>
                        <div class="right-title">
                            {{item.title}}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    filters: {//限制文本显示字数,超出部分用...代替
        ellipsis (value) {
        if (!value) return ''
        if (value.length > 10) {
            return value.slice(0,15) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
        }
            return value
        }
    },
    data(){
        return{
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                page: 1,
                page_size: 12,
                cate_id: this.$route.query.cate_id ? this.$route.query.cate_id : "",
            },
            isActive:false,
            artCate:[],
            cate_name:"",
            //左侧下标
            ind:0,
            list:[],
            list1:[],
        }
    },
    mounted() {
        this.news_hit();
        this.news_selection();
        this.getList(1);
        this.getArticleCate();
        this.getArticleList(this.$route.query.cate_id);
    },
    methods:{
        //热门文章
        news_hit(){
            this.$api.getArticle.news_hit({}).then(res => {
                if (res.code == 200) {
                    this.list = res.result;
                    // console.log(this.list)
                    // console.log(this.list)
                    // console.log(this.list.data[0].title)
                }
            });
        },
        //精选文章
        news_selection(){
            this.$api.getArticle.news_selection({}).then(res => {
                if (res.code == 200) {
                    this.list1 = res.result;
                    // console.log(this.list1)
                }
            });
        },
        getArticleCate(){
            this.$api.getArticle.getNewsCate({}).then(res => {
                if (res.code == 200) {
                    this.cate_name = [];
                    var arr = res.result;
                    this.artCate = res.result;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate_name = this.artCate[index].title
                        } 
                        // console.log(this.cate_name.piclink)
                    });
                    // console.log(this.artCate) 
                }
            });
        },
        //获取所有子分类热销产品
        getArticleList(cate_id) {
            var that = this;
            var params = {};
            params.cate_id = cate_id || "";
            this.dialogVisible = true;
            this.LogLoading = true;
            that.$api.getArticle.getNewsList(params, this.tableFrom).then(res => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                }
            }).catch((res) => {
                    this.$message.error(res.message);
                    this.listLoading = false;
                });
        },
        // 列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            // console.log(this.tableFrom)
            this.$api.getArticle.getNewsList(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.tableData.cate_id = this.$route.query.cate_id;
                    this.listLoading = false;
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        //左侧下标
        left_item(index){
            this.ind = index;
            // console.log(this.ind)
        },
    }
}
</script>

<style scoped>
    a{
        color: black;
    }
    .content{
        /* border: 1px solid red; */
        width: 1200px;
        margin: 40px auto;
        display: flex;
    }
    .content-left{
        /* border: 1px solid blue; */
        width: 140px;
    }
    .left-item{
        /* border: 1px solid; */
        display: flex;
        margin-left: 14px;
        /* line-height: 34px; */
        font-size: 14px;
        margin-top: 14px;
    }
    .left-item>.left-item-title:nth-child(1)>span>a{
        color: white;
    }
    .left-item>.left-item-title:nth-child(1)>span{
        /* border: 1px solid red; */
        border-radius: 14px;
        padding: 5px 24px 5px 24px;
        display: inline-block;
        background-color: #d01e1e;
    }
    .left-item-img{
        width: 36px;
    }
    .left-item-title{
        flex: 1;
        margin-top: 3px;
    }
    .left-item-img img{
        width: 24px;
    }
    .content-con{
        /* border: 1px solid red; */
        width: 800px;
    }
    .con-link{
        display: flex;
        padding-bottom:12px;
        margin-bottom: 12px;
        border-bottom: 1px solid gainsboro;
    }
    .con-item-img{
        /* display: inline-block; */
        width: 240px;
    }
    .con-item-div{
        /* display: inline-block; */
        flex: 1;
    }
    .con-item-p{
        font-size: 20px;
        line-height: 20px;
        font-weight: bold;
        margin-top: 4px;
    }
    .con-item-p1{
        font-size: 16px;
        line-height: 16px;
        margin-top: 14px;
        color: gray;
    }
    .con-div{
        margin-top: 20px;
    }
    .content-right{
        /* border: 1px solid red; */
        flex: 1;
    }
    .right-top{
        /* border: 1px solid red; */
        padding: 10px;
        margin-top: 10px;
        background-color: #ececec;
    }
    .right-top>p{
        font-size: 17px;
        color: black;
        font-weight: bold;
    }
    
    .right-item{
        /* border: 1px solid blue; */
        margin-top: 10px;
    }
    .right-a{
        display: flex;
    }
    .right-img{
        width: 110px;
    }
    .right-title{
        flex: 1;
        font-size: 14px;
        color: gray;
        margin-top: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/article/Index.vue